import {
    useContext
} from 'react';

import {
    useCurationConfigValue,
    useGetFocusedInstanceIdValue
} from './widgetConfiguration.js';

import {
    useGetExportConfig,
    useBridgingDashboardModel
} from './exportConfigurationHooks.js';

import ExportContext from '../contexts/exportContext.js';

export function useIsExporting() {
    return useContext(ExportContext);
}

export function useIsSingleWidgetExport() {
    const focusedInstanceId = useGetFocusedInstanceIdValue();
    return useIsExporting() && focusedInstanceId;
}

export function useIsExportingPNG() {
    const format = useCurationConfigValue('format');
    return useIsExporting() && format === RivalIQ.enums.exportFormat.PNG;
}

export function useIsExportingPDF() {
    const format = useCurationConfigValue('format');
    return useIsExporting() && format === RivalIQ.enums.exportFormat.PDF;
}

export function useIsExportingPPT() {
    const format = useCurationConfigValue('format');
    return useIsExporting() && format === RivalIQ.enums.exportFormat.PPT;
}

// This hook is a little hacky - if we're exporting a PPT slide, it'll squirrel away the slide elements on the current
// models.ReactCurationBridge instance. That instance will then return those elements in getSlideElements (which on
// export will be written to a data file in the export directory for usage later).
export function useRegisterSlideElementsForPPTExport(instanceId, slideElements) {
    const isExportingPPT = useIsExportingPPT();
    const focusedInstanceId = useGetFocusedInstanceIdValue();
    const onlyInstanceId = useCurationConfigValue('onlyInstanceId');

    if (isExportingPPT &&
        (focusedInstanceId === instanceId || onlyInstanceId === instanceId)) {
        RivalIQ.curation._setSlideElements(slideElements);
    }
}

export function useBranding() {
    const branding = RivalIQ.state.view.getActiveBranding();

    return branding.attributes;
}

// Returns a function that can be used to setup an export.
// a `type` field that can key into the `exportDefinitions` in `csvEportServices.js`.
export function useSetupExport(instanceId, format, exportType) {

    const exportConfig = useGetExportConfig(instanceId) || {};
    const {supportedExportFormats} = exportConfig;

    return useBridgingDashboardModel(instanceId, dashboardModel => {
        switch (exportType) {
            case RivalIQ.enums.exportType.DOWNLOAD:
                return RivalIQ.export.download(format, dashboardModel);

            case RivalIQ.enums.exportType.EMAIL:
                return RivalIQ.export.email(_.first(supportedExportFormats), dashboardModel);

            case RivalIQ.enums.exportType.SCHEDULE:
                return RivalIQ.export.schedule(dashboardModel);

            default:
                throw new Error(`Unknown export type: ${exportType}`);
        }
    }, [instanceId, format, exportType]);
}
